import Api from "./Api";

export default {
    getAllClientUserList(payload) {
        let AllClientUserList = Api().post(
            "Api_ClientUser/getAllClientUser.php",
            payload
        );
        return AllClientUserList;
    },
    getAllAgentUserList(payload) {
        let AllAgentUserList = Api().post(
            "AgenDash_Api/getAllAgentUser.php",
            payload
        );
        return AllAgentUserList;
    },
    getAllActive(payload) {
        let AllClientUserList = Api().post(
            "Api_Master/activateUser.php",
            payload
        );
        return AllClientUserList;
    },
    getAllOverseaLock(payload) {
        let AllUserList = Api().post("Api_ClientUser/getAllClientUser.php", payload);
        return AllUserList;
    },

};



// WEBPACK FOOTER //
// ./src/services/ClientUserService.js